import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Update an existing SPOC user.
 * PUT api/SpocCreation/update-spoc
 *
 * Body: { userId, userName, email, lobType, departments: string[], modifiedBy }
 */
export const updateSpocAction = async (userId, formData) => {
  const user = getUserData();

  // departments must be an array of strings
  const departments = Array.isArray(formData.departments)
    ? formData.departments
    : [];

  const payload = {
    userId: Number(userId) || 0,
    userName: formData.employeeName?.trim() || "",
    email: formData.email?.trim() || "",
    lobType: formData.lob?.trim() || "",
    departments,
    modifiedBy: user?.email || user?.userName || "admin",
  };

  console.log(
    "[updateSpoc] → PUT update-spoc | userId:",
    userId,
    "| payload:",
    payload,
  );

  try {
    const response = await apiClient.put(ATP_API_URL.SPOC_UPDATE, payload);

    console.log("[updateSpoc] ← response:", response?.status, response?.data);

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to update SPOC",
        };
      }
      return {
        success: true,
        message: response.data?.message || "SPOC updated successfully",
        data: response.data,
      };
    }

    return { success: false, message: "Failed to update SPOC" };
  } catch (error) {
    console.error(
      "[updateSpoc] Error:",
      error?.response?.data || error.message,
    );
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Failed to update SPOC",
    };
  }
};
